__turbopack_context__.v({
  "className": "caveat_5a0f2acc-module__xZz_CG__className",
});
